export const LAST_ADMIN_ROUTE_KEY = 'ifstatic:lastAdminRoute';
export const ADMIN_AUTH_TOKEN_KEY = 'ifstatic:adminToken';
export const ADMIN_UNAUTHORIZED_EVENT = 'ifstatic:admin-unauthorized';
export const DEFAULT_ADMIN_ROUTE = '/admin/services';

export const getStoredAdminRoute = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_ADMIN_ROUTE;
  }
  const stored = window.localStorage.getItem(LAST_ADMIN_ROUTE_KEY);
  return stored && stored.startsWith('/admin') ? stored : DEFAULT_ADMIN_ROUTE;
};

export const getStoredAdminToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(ADMIN_AUTH_TOKEN_KEY);
};

export const persistAdminToken = (token) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (token) {
    window.localStorage.setItem(ADMIN_AUTH_TOKEN_KEY, token);
  } else {
    window.localStorage.removeItem(ADMIN_AUTH_TOKEN_KEY);
  }
};

export const broadcastUnauthorized = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(ADMIN_UNAUTHORIZED_EVENT));
};
